import * as React from "react";
import {
    Box, Container, CircularProgress, Alert, Stack, Divider } from "@mui/material";
import ButtonComponent from "components/Button";
import {
    schema,
} from "./helper";
import { getPrice, isMarketPlace, isAuthorized, getURI} from "helpers/utils";


import {useState, useEffect} from "react";
import {H2, H5, H6} from "components/CustomTypography";
import ImageAlbum from "components/elements/main/ImageAlbum";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopOffersSlider from "components/elements/user/offers/ShopOffersSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import ShopHeaderShopOverlay from "components/elements/user/shops/ShopHeaderShopOverlay";
import ShopHeaderOurCollection from "components/elements/user/shops/ShopHeaderOurCollection";
import MockProductImage from "components/elements/main/MockProductImage";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions/user/user-base.actions";

const UserProductDetail = ({
   selectedProduct, currency, onCancel, productdetail, isLoading, history, onAddToFavlistClicked,
   userMainGetShopInfoById, excludeHome, wholesale, reqStatus, serviceError, tryonCredits,
   tryonProfileImage, virtualTryOnResult, generateVirtualTryOn, getTryOnProfileImage, getTryOnCredits
}) => {

    const [share, setShare] = useState(false);
    const [state, setState] = useState({});
    const [isGenerating, setIsGenerating] = useState(false);

    let isModalSearch = false;
    const {product, shops} = productdetail;

    const {
     created_at: createdAt, _id: _id, status, message
  } = selectedProduct || {};

  const [blur, setblur] = React.useState({
    status: false,
  });

  useEffect(() => {
    if (isAuthorized()) {
      getTryOnCredits();
    }
  }, []);

  useEffect(() => {
    if (reqStatus === "GENERATE_VIRTUAL_TRYON_SUCCESS") {
      setIsGenerating(false);
      history.push(getURI(process.env.REACT_APP_TYPE, "tryon", ""));
    } else if (reqStatus === "GENERATE_VIRTUAL_TRYON_FAILURE") {
      setIsGenerating(false);
      history.push(getURI(process.env.REACT_APP_TYPE, "tryon", ""));
    }
  }, [reqStatus]);

  const handleTryOn = () => {
    if (!product || !product.product_id) {
      alert("Product information not available");
      return;
    }

    if (!tryonProfileImage) {
      alert("Please upload a profile image first in your account settings");
      return;
    }

    if (tryonCredits?.balance <= 0) {
      alert("You don't have enough credits for virtual try-on");
      return;
    }

    setIsGenerating(true);
    generateVirtualTryOn(product.product_id, tryonProfileImage._id, 1);
  };

    const onAddToFav = () => {
        onAddToFavlistClicked(product.id);
    };

  const hasError = () => {
    try {
      return !schema.validateSync(selectedProduct);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.status);

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, selectedProduct);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

    const handleTextFieldChange = (event, field) => {
        setState(event.target.value, field);
    };

    const handleVisitPage = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "tryon_profile", ""))
    };

    const renderProductInformation = () => (

        <Box>
            <H2 fontSize={18} sx={{ mb: "2", mt: "4", textTransform: "capitalize" }} textAlign="left" title={product.name} ellipsis>
                {product.name}
            </H2>
            <H5 fontSize={14} textAlign="left" ellipsis>
                {product.description}
            </H5>
        </Box>
    );

    const renderProductPhotos = () => (
        <Box>
            <ImageAlbum images={product.images} mainOnly={true} />
        </Box>
    );

    const renderProductBuyFromShop = () => (
        <Box>
            {shops.map((shop, index) => (
                <Box>
                    <ShopHeaderShopOverlay userMainGetShopInfoById={userMainGetShopInfoById} history={history} shopId={shop.id}/>
                </Box>
            ))}
        </Box>
    );

    const renderProductShopMoreInfo = () => (
        <Box>
            {shops.map((shop, index) => (
                <Box>
                    <Box onClick={() => history.push(`/shop/${shop.id}/products/${product.id}`)} alignContent="center" width="100%" display="flex" pt={3} pb={3}>
                        <Box width="70%">
                            <H2 fontSize={18}>
                                {getPrice(shop, currency)}
                            </H2>
                        </Box>
                        <Box width="30%" display="flex" justifyContent="flex-end" alignItems="right">
                            <ButtonComponent
                                type="primary"
                                variant="contained"
                                name="Buy"
                                size="small"
                                onClick={() => history.push({
                                        pathname: `/shop/${shop.id}/products/${product.id}`,
                                        state: {
                                            ws: wholesale
                                        },
                                })}
                            />
                        </Box>
                    </Box>
                    <ShopProductPopularSlider shopId={shop.id} />
                    <ShopProductNewSlider shopId={shop.id} />
                    <ShopOffersSlider shopId={shop.id} />
                </Box>
                ))}
        </Box>
    );

    const renderVirtualTryOn = () => {
        if (!isAuthorized()) return null;

        return (
            <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }} />
                <Stack spacing={2}>
                    {tryonCredits && (
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <H5 fontSize={16}>Try-On Credits Available:</H5>
                            <H5 fontSize={16} color="primary">{tryonCredits.balance || 0}</H5>
                        </Box>
                    )}

                    <ButtonComponent
                        type="primary"
                        variant="contained"
                        name={isGenerating ? "Generating..." : "Try On! (Using AI)"}
                        size="medium"
                        fullWidth
                        onClick={handleTryOn}
                        disabled={isGenerating || !tryonProfileImage || (tryonCredits?.balance <= 0)}
                        startIcon={isGenerating && <CircularProgress size={20} />}
                    />

                    {!tryonProfileImage && (
                        <Alert severity="info">
                            Upload a profile image use virtual try-on
                                                <ButtonComponent
                                                    type="primary"
                                                    variant="contained"
                                                    size="small"
                                                     name="Upload Profile Image"
                                                    onClick={handleVisitPage}  />
                        </Alert>
                    )}

                    {virtualTryOnResult && virtualTryOnResult.generated_images && virtualTryOnResult.generated_images.length > 0 && (
                        <Box>
                            <H5 fontSize={14} sx={{ mb: 2 }}>Try-On Result:</H5>
                            {virtualTryOnResult.generated_images.map((img, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <img
                                        src={img.cdn?.secure_url || img.url}
                                        alt={`Try-on result ${index + 1}`}
                                        style={{ width: '100%', borderRadius: '8px' }}
                                    />
                                </Box>
                            ))}
                        </Box>
                    )}
                </Stack>
            </Box>
        );
    };


    return (
        <Container>
            <Container maxWidth="md">

                {isLoading && <MockGeneralHeader /> }

                {/*!isLoading && renderProductInformation()*/}

                {!isLoading && renderProductBuyFromShop()}

                <ShopHeaderBack onCancel={onCancel} history={history} />

                {isLoading && <MockProductImage />}
                {!isLoading && renderProductPhotos()}
                {!isLoading && product && renderVirtualTryOn()}

                {!isLoading && renderProductShopMoreInfo()}
            </Container>
        </Container>
    );
};

// Mapping Props and State
const userProductDetail = connect(
    ({ userbootupInfo }) => ({
        reqStatus: userbootupInfo.reqStatus,
        isLoading: userbootupInfo.isLoading,
        serviceError: userbootupInfo.serviceError,
        tryonCredits: userbootupInfo.tryonCredits,
        tryonProfileImage: userbootupInfo.tryonProfileImage,
        virtualTryOnResult: userbootupInfo.virtualTryOnResult,
    }),
    (dispatch) =>
        bindActionCreators(
            {...Actions}, dispatch)
)(UserProductDetail);

export { userProductDetail as default };
